"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AuthContentHeader_1 = __importDefault(require("./AuthContentHeader/AuthContentHeader"));
var AuthContentBody_1 = __importDefault(require("./AuthContentBody/AuthContentBody"));
var AuthContentWrapper = (0, styled_components_1.default)('main')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  overflow: hidden;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: ", ") and (max-width: 1600px) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: 1601px) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: 768px) and (min-height: 550px) {\n    padding-top: 19px;\n  }\n\n  @media (max-width: 575px) {\n    height: 100%;\n  }\n\n  @media (max-height: ", ") {\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  overflow: hidden;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: ", ") and (max-width: 1600px) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: 1601px) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  @media (min-width: 768px) and (min-height: 550px) {\n    padding-top: 19px;\n  }\n\n  @media (max-width: 575px) {\n    height: 100%;\n  }\n\n  @media (max-height: ", ") {\n    padding: 0;\n  }\n"])), function (_a) {
    var hasFooter = _a.hasFooter;
    return hasFooter ? '100%' : '95%';
}, function (props) {
    return props.theme.variables.contentLeftMarginFull;
}, function (props) {
    return props.theme.variables.contentRightMarginFull;
}, function (props) {
    return props.theme.variables.smallestWidthBreakpoint;
}, function (props) {
    return props.theme.variables.smallerWidthBreakpoint1;
}, function (props) {
    return props.theme.variables.contentLeftMargin575;
}, function (props) {
    return props.theme.variables.contentRightMargin575;
}, function (props) {
    return props.theme.variables.smallerWidthBreakpoint2;
}, function (props) {
    return props.theme.variables.midSizeWidthBreakpoint1;
}, function (props) {
    return props.theme.variables.contentLeftMargin768;
}, function (props) {
    return props.theme.variables.contentRightMargin768;
}, function (props) {
    return props.theme.variables.midSizeWidthBreakpoint2;
}, function (props) {
    return props.theme.variables.contentLeftMargin1024;
}, function (props) {
    return props.theme.variables.contentRightMargin1024;
}, function (props) {
    return props.theme.variables.contentLeftMargin1600;
}, function (props) {
    return props.theme.variables.contentRightMargin1600;
}, function (props) { return props.theme.variables.tinyHeightBreakpoint; });
var AuthContent = function (_a) {
    var footer = _a.footer, header = _a.header, headerStyle = _a.headerStyle, bodyStyle = _a.bodyStyle, children = _a.children;
    return (react_1.default.createElement(AuthContentWrapper, { hasFooter: !!footer },
        react_1.default.createElement(AuthContentHeader_1.default, { style: headerStyle }, header),
        react_1.default.createElement(AuthContentBody_1.default, { style: bodyStyle }, children),
        footer));
};
AuthContent.defaultProps = {
    headerStyle: {},
    bodyStyle: {},
    header: undefined,
    footer: undefined
};
exports.default = AuthContent;
var templateObject_1;
//# sourceMappingURL=AuthContent.js.map